<template>
    <div class="main">
        <sub-title
            title="企业介绍"
            class="title"
        ></sub-title>
        <div class="content">
            <div class="left-part">
                <div
                    class="video-placeholder"
                    v-show="pauseState"
                    @click="playHandler"
                >
                    <img src="/images/about/video_bg.png" />

                    <img
                        class="icon-play"
                        src="/images/about/icon-play.png"
                        alt=""
                    />
                </div>

                <video
                    ref="video"
                    v-show="!pauseState"
                    class="video"
                    src="/movie.mp4"
                    controls
                ></video>
            </div>
            <div class="right-part">
                <div class="sub-title">中惠科技</div>
                <div class="text">
                    <p> &nbsp;&nbsp;中惠科技既有在工程建设领域耕耘20余年的行业精英,又有专注互联网发展的技术英才，多年来通过对建设方、咨询机构、造价机构、招标机构需求的分析研究，逐步形成了“惠系列”产品，实现对工程建设领域和政府的信息化产品与服务。
                    </p>

                    <p> &nbsp;&nbsp;通过打造基于工程领域大数据、人工智能、装配式建筑、移动化工程管理的“领先的工程建设SAAS服务提供商”，以工程建设SAAS服务平台为定位，专注于面向投资人、项目建设单位、工程咨询机构、政府及工程行业人员等客户提供完整的工程技术信息化解决方案；逐步实现360度解决方案覆盖能力，形成基于云端（Web/App）和工程大数据汇集提供更好的用户体验，在工程细分领域打造一个核心技术领先、客户黏性高、团队能力强、竞争优势明显的行业标杆，探索可重复、可扩展、可盈利的为客户提供全方位的、平台化的“互联网+”工程建设服务模式。
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SubTitle from '../../index/component/sub-title.vue';
export default {
    components: { SubTitle },
    data() {
        return {
            pauseState: true,
        };
    },
    created() {},
    methods: {
        playHandler() {
            this.pauseState = false;
            this.$refs.video.play();
        },
    },
    mounted() {},
    computed: {},
};
</script>
<style scoped lang="scss">
.main {
    padding-bottom: 20px;

    .title {
        margin-bottom: 47px;
    }
}

.content {
    height: 412px;
    background: #fff;
    box-shadow: 0px 17px 44px 0px rgba(0, 0, 0, 0.09);
    padding: 13px 11px;
    display: flex;

    .left-part {
        width: 600px;
        .video-placeholder {
            width: 573px;
            height: 387px;
            position: relative;
            cursor: pointer;

            .icon-play {
                width: 60px;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                opacity: 0.6;
                transition: all 0.3s;
            }

            &:hover {
                .icon-play {
                    opacity: 0.9;
                }
            }
        }

        .video {
            width: 573px;
            height: 387px;
        }
    }

    .right-part {
        padding: 0px 10px 10px 22px;
        .sub-title {
            font-size: 18px;
            text-align: center;
            line-height: 35px;
            color: #131415;
        }
        .text {
            font-size: 15px;
            line-height: 29px;
            color: #333333;
            text-indent: 20px;

            p {
                &:not(:last-child) {
                    margin-bottom: 44px;
                }
            }
        }
    }
}
</style>
